import { z } from 'zod';
import { SystemSchema } from '../../entities/system/system.schema';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Add System Request Schema
 * POST /api/v2/systems
 */ export const AddSystemRequestSchema = z.object({
    name: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    description: z.string().optional(),
    systemOwner: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    category: z.string().optional(),
    url: z.string().optional(),
    licenceSeats: z.number(ErrorCode.FIELD_INVALID).int().min(0).optional()
});
/**
 * Add System Response Schema
 * POST /api/v2/systems
 */ export const AddSystemResponseSchema = z.object({
    data: SystemSchema
});

//# sourceMappingURL=add-system.schema.js.map